import sortBy from 'lodash/sortBy'
import StorageManager from 'services/StorageManager'
import { isClient } from 'utils/runtimeUtils'
import {
  PENDING_TILES_STORAGE_KEY,
  TILES_STORAGE_KEY,
} from 'components/TilesProvider/TilesProvider.consts'

function isStorageRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value)
}

function readTilesFromStorageKey(
  storageKey: string
): Record<string, unknown>[] {
  if (!isClient()) return []

  const storedTiles = StorageManager.get<unknown>(storageKey)
  if (!Array.isArray(storedTiles)) return []

  return sortBy(storedTiles.filter(isStorageRecord), 'uploadedAt')
}

export function readRawTilesFromStorage({
  includePending = true,
}: {
  includePending?: boolean
} = {}): Record<string, unknown>[] {
  const storedTiles = readTilesFromStorageKey(TILES_STORAGE_KEY)
  const pendingTiles = includePending
    ? readTilesFromStorageKey(PENDING_TILES_STORAGE_KEY)
    : []

  return [...storedTiles, ...pendingTiles]
}
